export default __webpack_public_path__ + "static/media/explore_destination_img4.ae6ef800.jpg";